<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  agent: { type: String, required: true },
});

const { t } = useI18n();

// Chat URLs served by the n8n "Chat Trigger" workflows (one per briefing agent).
// Paste each hosted-chat URL here once the workflows exist, e.g.:
//   'https://n8n.agenciarosh.com.br/webhook/<id>/chat'
const AGENT_URLS = {
  questionador:
    'https://n8n.agenciarosh.com.br/webhook/briefing-questionador-rosh/chat',
  arquiteto:
    'https://n8n.agenciarosh.com.br/webhook/briefing-arquiteto-rosh/chat',
};

const url = computed(() => AGENT_URLS[props.agent] ?? '');
const title = computed(() => {
  if (props.agent === 'questionador') {
    return t('SIDEBAR.BRIEFING.QUESTIONADOR');
  }
  if (props.agent === 'arquiteto') {
    return t('SIDEBAR.BRIEFING.ARQUITETO');
  }
  return '';
});
</script>

<template>
  <div class="flex flex-col w-full h-full bg-n-background">
    <header
      class="flex items-center flex-shrink-0 h-12 px-4 border-b border-n-weak"
    >
      <h1 class="text-base font-medium text-n-slate-12">{{ title }}</h1>
    </header>
    <div class="relative flex-grow min-h-0">
      <iframe
        v-if="url"
        :src="url"
        :title="title"
        class="absolute inset-0 w-full h-full border-0"
        allow="clipboard-write"
      />
      <div
        v-else
        class="flex items-center justify-center w-full h-full px-6 text-sm text-center text-n-slate-11"
      >
        {{ t('SIDEBAR.BRIEFING.NOT_CONFIGURED') }}
      </div>
    </div>
  </div>
</template>
